import { plane as createPlane } from "primitive-geometry";

const numAxis = 8;

function generateAxisIcons({ mobile, lastRing, normalizationFactor }) {
  const r = 7;
  const plane = createPlane({ sx: mobile ? 1 : 0.75 });
  const offsets = [];
  const instanceUvs = [];

  for (let i = 0; i < numAxis; i++) {
    const axisR = mobile
      ? 10 * normalizationFactor * lastRing.radius[i] + 1.6
      : r;
    // const a = -(Math.PI * 2 * i) / numAxis + Math.PI / 2;
    const a = (i / numAxis) * Math.PI * 2;
    offsets.push([axisR * Math.cos(a), axisR * Math.sin(a), 0]);
    const iconI = (i - 2 + numAxis) % numAxis;
    instanceUvs.push([(iconI * 1) / numAxis, 0, 1 / numAxis, 1]);
  }

  return {
    ...plane,
    offsets: offsets,
    instanceUvs: instanceUvs,
    instances: 3,
  };
}

export default generateAxisIcons;
